import React from "react";
import Creatable from "react-select/creatable";
import ReactSelect from "react-select";
import { classnames } from "../../lib/classNameBuilders";
import { LoadingIndicator } from "./LoadingIndicator";
import result from "lodash/result";
import isFunction from "lodash/isFunction";
const isValidNewOption = () => true;
export const Select = ({ options, className, valueAccessor, labelAccessor, loading, onChange, onBlur, onFocus, value, onInputChange, onCreateOption, createNewText, clearable, disabled, placeholder, open, required, error }) => {
    const handleBlur = event => {
        if (onBlur)
            onBlur(value, event);
    };
    const runAccessor = (accessor, option) => {
        if (isFunction(accessor)) {
            return accessor(option);
        }
        else {
            return result(option, accessor);
        }
    };
    const handleGetOptionLabel = option => {
        if (option.__isNew__) {
            return `${createNewText || "Create new"} ${option.value}`;
        }
        else if (labelAccessor) {
            return runAccessor(labelAccessor, option);
        }
        else {
            return option.label;
        }
    };
    const handleGetOptionValue = option => {
        if (option.__isNew__) {
            return option.value;
        }
        else if (valueAccessor) {
            return runAccessor(valueAccessor, option);
        }
        else {
            return option.value;
        }
    };
    const handleInputChange = (value) => {
        if (onInputChange)
            onInputChange(value);
    };
    const commonProps = {
        options,
        value: value || null,
        placeholder: loading ? "Loading..." : placeholder,
        className: classnames("select", className, error ? "select--isError" : null, required && !error ? "select--isRequired" : null),
        classNamePrefix: "select",
        getOptionLabel: handleGetOptionLabel,
        getOptionValue: handleGetOptionValue,
        tabSelectsValue: false,
        isLoading: loading,
        isClearable: clearable,
        isDisabled: disabled,
        onChange,
        onFocus,
        onInputChange: handleInputChange,
        onBlur: handleBlur,
        components: { LoadingIndicator },
        menuIsOpen: open
    };
    const renderCreateable = () => {
        return (React.createElement(Creatable, Object.assign({}, commonProps, { className: classnames(commonProps.className, "select--createable"), onCreateOption: onCreateOption, createOptionPosition: "first", isValidNewOption: isValidNewOption, allowCreateWhileLoading: true, captureMenuScroll: false })));
    };
    const renderSelect = () => {
        return React.createElement(ReactSelect, Object.assign({}, commonProps));
    };
    if (onCreateOption)
        return renderCreateable();
    return renderSelect();
};
//# sourceMappingURL=Select.js.map